module.exports = __webpack_public_path__ + "img/ivanov.33dd175a.jpg";